import { CompanyDto } from './company.dto';
import { ParticipantDto } from './participant.dto';
import { RegistrationType } from './registration.enum';
import { RepresentativeDto } from './representative.dto';
import { RegistrationStatus } from './status.enum';

export interface RegistrationDto {
  technicalId: string;
  createdAt: Date;
  participants: ParticipantDto[];
  company: CompanyDto;
  representative: RepresentativeDto;
  type: RegistrationType;
  totalAmount: number;
  status: RegistrationStatus;
  comment?: string;
  pass?: RegistrationPass;
}

export interface RegistrationValidation {
  technicalId: string;
  status: RegistrationStatus;
  participants: ParticipantDto[];
}

export enum RegistrationPass {
  PASS_1 = 'PASS_1',
  PASS_2 = 'PASS_2',
  PASS_3 = 'PASS_3',
}
